import React from 'react';
import { Box, BoxProps, useTheme, useMediaQuery } from '@mui/material';
import AWSLogo from '../assets/images/logos/AWS.svg';
import KubernetesLogo from '../assets/images/logos/Kubernetes.svg';
import ReactLogo from '../assets/images/logos/React.svg';
import SalesforceLogo from '../assets/images/logos/Salesforce.svg';
import OperouteLogo from '../assets/images/logos/Operoute.svg';

interface TechStackSectionProps extends BoxProps {
  // Add any additional props here if needed
}

const TechStackSection: React.FC<TechStackSectionProps> = ({ sx, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box 
      sx={{ 
        width: '100%',
        height: 'auto',
        minHeight: isMobile ? '100px' : '180px',
        position: 'relative',
        background: '#050505',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '15px 0' : '30px 0',
        overflow: 'visible',
        ...sx 
      }} 
      {...props}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: isMobile ? '8px' : isTablet ? '15px' : '20px',
          width: '100%',
          maxWidth: '1200px',
          px: { xs: 2, sm: 3, md: 4, lg: 5 },
          py: isMobile ? 2 : 3,
          flexWrap: 'nowrap',
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {/* AWS Logo */}
        <Box
          sx={{
            height: isMobile ? '40px' : isTablet ? '60px' : '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={AWSLogo}
            alt="AWS"
            sx={{
              height: '100%',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>

        {/* Kubernetes Logo */}
        <Box
          sx={{
            height: isMobile ? '40px' : isTablet ? '60px' : '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={KubernetesLogo}
            alt="Kubernetes"
            sx={{
              height: '100%',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>

        {/* React Logo */}
        <Box
          sx={{
            height: isMobile ? '40px' : isTablet ? '65px' : '85px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={ReactLogo}
            alt="React"
            sx={{
              height: '100%',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>

        {/* Salesforce Logo */}
        <Box
          sx={{
            height: isMobile ? '40px' : isTablet ? '60px' : '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={SalesforceLogo}
            alt="Salesforce"
            sx={{
              height: '100%',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>

        {/* Operoute Logo */}
        <Box
          sx={{
            height: isMobile ? '40px' : isTablet ? '60px' : '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={OperouteLogo}
            alt="Operoute"
            sx={{
              height: '100%',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TechStackSection; 